import { isEmpty } from "lodash";

const FormTextarea = ({
  id,
  label,
  error,
  value,
  touched,
  placeholder,
  onChange,
}: {
  id: string;
  label?: string;
  error?: string;
  value?: string;
  placeholder?: string,
  touched?: boolean;
  onChange: (text: string) => void;
}) => {
  return (
    <div className="w-full">
      {label && (
        <label
          htmlFor={label}
          className="block mb-2 text-sm font-medium text-valhalla"
        >
          {label}
        </label>
      )}
      <textarea
        id={id}
        rows={4}
        name={id}
        value={value}
        className="nl-input"
        placeholder={isEmpty(placeholder) ? "Write your thoughts here..." : placeholder}
        onChange={(e) => onChange(e.target.value)}
      />
      {!isEmpty(error) && touched && (
        <span className="mt-1 block text-xs font-normal text-rose-500	">
          {error}
        </span>
      )}
    </div>
  );
};

export default FormTextarea;
